require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-women-in-technology-announces-scholarship-fund-for-code-fellows-women-only-class.json") })
        }
      }, "path---blog-women-in-technology-announces-scholarship-fund-for-code-fellows-women-only-class");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-women-in-technology-announces-scholarship-fund-for-code-fellows-women-only-class!./.cache/json/blog-women-in-technology-announces-scholarship-fund-for-code-fellows-women-only-class.json
// module id = 1148
// module chunks = 231608221292675